import { render, staticRenderFns } from "./SingularityBadge.vue?vue&type=template&id=1564a505&"
import script from "./SingularityBadge.vue?vue&type=script&lang=ts&"
export * from "./SingularityBadge.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityBadge.vue?vue&type=style&index=0&id=1564a505&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports